/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: role.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AddPermissionToRoleRequest,
  AddPermissionToRoleResponse,
  CloneRoleRequest,
  CloneRoleResponse,
  CreateRoleRequest,
  CreateRoleResponse,
  DeleteRoleRequest,
  DeleteRoleResponse,
  GetRoleRequest,
  GetRoleResponse,
  ListRolesRequest,
  ListRolesResponse,
  ReloadRoleCacheRequest,
  ReloadRoleCacheResponse,
  RemovePermissionFromRoleRequest,
  RemovePermissionFromRoleResponse,
  SearchRolesRequest,
  SearchRolesResponse,
  UpdateRoleRequest,
  UpdateRoleResponse,
} from '../types/role';

export const createRoleService = (transport: Transport) => ({
  async createRole(
    request: CreateRoleRequest,
    options: RequestOptions = {},
  ): Promise<CreateRoleResponse> {
    const url = getApiPath(API_METHODS.RoleService.CreateRole);
    return transport.post<CreateRoleResponse>(url, request, options);
  },

  async getRole(request: GetRoleRequest, options: RequestOptions = {}): Promise<GetRoleResponse> {
    const { role_id } = request;
    const url = getApiPath(API_METHODS.RoleService.GetRole, { role_id });
    return transport.get<GetRoleResponse>(url, options);
  },

  async updateRole(
    request: UpdateRoleRequest,
    options: RequestOptions = {},
  ): Promise<UpdateRoleResponse> {
    const { role_id, ...body } = request;
    const url = getApiPath(API_METHODS.RoleService.UpdateRole, { role_id });
    return transport.post<UpdateRoleResponse>(url, body, options);
  },

  async deleteRole(
    request: DeleteRoleRequest,
    options: RequestOptions = {},
  ): Promise<DeleteRoleResponse> {
    const { role_id } = request;
    const url = getApiPath(API_METHODS.RoleService.DeleteRole, { role_id });
    return transport.delete<DeleteRoleResponse>(url, options);
  },

  async listRoles(
    request: ListRolesRequest,
    options: RequestOptions = {},
  ): Promise<ListRolesResponse> {
    const url = getApiPath(API_METHODS.RoleService.ListRoles);
    return transport.get<ListRolesResponse>(url, { params: request, ...options });
  },

  async addPermissionToRole(
    request: AddPermissionToRoleRequest,
    options: RequestOptions = {},
  ): Promise<AddPermissionToRoleResponse> {
    const { role_id, ...body } = request;
    const url = getApiPath(API_METHODS.RoleService.AddPermissionToRole, { role_id });
    return transport.post<AddPermissionToRoleResponse>(url, body, options);
  },

  async removePermissionFromRole(
    request: RemovePermissionFromRoleRequest,
    options: RequestOptions = {},
  ): Promise<RemovePermissionFromRoleResponse> {
    const { role_id, ...body } = request;
    const url = getApiPath(API_METHODS.RoleService.RemovePermissionFromRole, { role_id });
    return transport.delete<RemovePermissionFromRoleResponse>(url, { data: body, ...options });
  },

  async searchRoles(
    request: SearchRolesRequest,
    options: RequestOptions = {},
  ): Promise<SearchRolesResponse> {
    const url = getApiPath(API_METHODS.RoleService.SearchRoles);
    return transport.get<SearchRolesResponse>(url, { params: request, ...options });
  },

  async cloneRole(
    request: CloneRoleRequest,
    options: RequestOptions = {},
  ): Promise<CloneRoleResponse> {
    const { role_id, ...body } = request;
    const url = getApiPath(API_METHODS.RoleService.CloneRole, { role_id });
    return transport.post<CloneRoleResponse>(url, body, options);
  },

  async reloadRoleCache(
    _request: ReloadRoleCacheRequest,
    options: RequestOptions = {},
  ): Promise<ReloadRoleCacheResponse> {
    const url = getApiPath(API_METHODS.RoleService.ReloadRoleCache);
    return transport.post<ReloadRoleCacheResponse>(url, {}, options);
  },
});

export type RoleService = ReturnType<typeof createRoleService>;
